import React from 'react';
import { useEffect, useState } from "react";
import Boll from '../assets/images/ball.png'
import Strpe1 from '../assets/images/stipe1.png'
import Strpe2 from '../assets/images/stripe2.png'
import img74 from '../assets/images/74.png'
import Win from '../assets/images/win.png'
import Logo from '../assets/images/Logo.png'

function Loader() {
    const [progress, setProgress] = useState<number>(0);
    const [isStrpe1Visible, setIsStrpe1Visible] = useState(true);

    useEffect(() => {
        // Simulate a process that updates progress
        const interval = setInterval(() => {
            setProgress(prev => {
                if (prev >= 100) {
                    clearInterval(interval);
                    return 100;
                }
                return prev + 10;
            });
        }, 300); // Increase progress by 10 every second

        return () => clearInterval(interval); // Clean up the interval on component unmount
    }, []);

    // Step 2: UseEffect to switch images after 4 seconds
    useEffect(() => {
        const timer = setTimeout(() => {
            setIsStrpe1Visible(false); // After 4 seconds, set Strpe1 to be hidden
        }, 4000); // 4000ms = 4 seconds

        // Cleanup the timer when the component unmounts
        return () => clearTimeout(timer);
    }, []); // Empty dependency array so this runs only once when the component mounts

    return (
        <>
            <div className="loderMain">
                <div style={{ width: '100%', position: 'relative', textAlign: 'center', margin: '0 auto', display: 'flex', justifyContent: 'center' }}>
                    <div className="typing">
                        <img src={Logo} alt="" className='img-fluid' />
                        <div className='d-flex justify-content-end'>
                            <span className="dotLoder"></span>
                            <span className="dotLoder"></span>
                            <span className="dotLoder"></span>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Loader;